import styled from 'styled-components/native'

import { StyledTextProps } from './types'

export const StyledText = styled.Text<StyledTextProps>`
  font-family: ${({ fontWeight }) =>
    // eslint-disable-next-line no-nested-ternary
    fontWeight === 'bold'
      ? 'Poppins-SemiBold'
      : fontWeight === 'black'
      ? 'Poppins-Black'
      : 'Poppins'};
  font-size: ${({ theme }) => theme.fonts.sizes.md}px;
  text-align: ${({ align }) => align};
  color: ${({ color = 'text', theme }) => theme.colors[color]};
  ${({ theme, fontSize }) => (fontSize ? `font-size: ${theme.fonts.sizes[fontSize]}px;` : null)}
  ${({ theme, fontWeight }) =>
    fontWeight ? `font-weight: ${theme.fonts.weights[fontWeight]};` : null}
  ${({ fontStyle }) => (fontStyle ? `font-style: ${fontStyle};` : null)}
  ${({ theme, type }) => (type ? `color: ${theme.colors.error};` : null)}
  ${({ theme, isCompact, fontSize }) =>
    isCompact && fontSize ? `line-height: ${theme.fonts.sizes[fontSize]}px;` : null}
`
